export const maxDate = `${new Date().getFullYear() + 1}-12-31`;
export const minDate = '1900-01-01';
